import daNavigation from './locales/da/navigation.json';
import daPmCommon from './locales/da/pmCommon.json';
import daPmDetails from './locales/da/pmDetails.json';
import daPmFinancials from './locales/da/pmFinancials.json';
import daPmPlanning from './locales/da/pmPlanning.json';
import daPmPlanningPanel from './locales/da/pmPlanningPanel.json';
import daPmPortfolio from './locales/da/pmPortfolio.json';
import daPmResources from './locales/da/pmResources.json';
import daPmShell from './locales/da/pmShell.json';
import daProjectManagement from './locales/da/projectManagement.json';
import enNavigation from './locales/en/navigation.json';
import enPmCommon from './locales/en/pmCommon.json';
import enPmDetails from './locales/en/pmDetails.json';
import enPmFinancials from './locales/en/pmFinancials.json';
import enPmPlanning from './locales/en/pmPlanning.json';
import enPmPlanningPanel from './locales/en/pmPlanningPanel.json';
import enPmPortfolio from './locales/en/pmPortfolio.json';
import enPmResources from './locales/en/pmResources.json';
import enPmShell from './locales/en/pmShell.json';
import enProjectManagement from './locales/en/projectManagement.json';

/**
 * Every translation, bundled. Static imports rather than Web's
 * `i18next-http-backend`: no window where keys show before their namespace
 * arrives, nothing to serve, and the unit tests read the same objects (ADR 0049).
 *
 * `navigation` and `projectManagement` are TimeLog Web's own files, copied
 * verbatim (see SOURCE.md) — reuse a key from them when its English AND its
 * meaning match. The `pm*` namespaces are this module's own keys, in Web's
 * format, so they can move into Web unchanged: `pmCommon` holds the glossary's
 * shared terms (docs/i18n-glossary.md), the rest one per area.
 */
export const resources = {
  en: {
    navigation: enNavigation,
    projectManagement: enProjectManagement,
    pmShell: enPmShell,
    pmCommon: enPmCommon,
    pmPortfolio: enPmPortfolio,
    pmFinancials: enPmFinancials,
    pmPlanning: enPmPlanning,
    pmPlanningPanel: enPmPlanningPanel,
    pmResources: enPmResources,
    pmDetails: enPmDetails,
  },
  da: {
    navigation: daNavigation,
    projectManagement: daProjectManagement,
    pmShell: daPmShell,
    pmCommon: daPmCommon,
    pmPortfolio: daPmPortfolio,
    pmFinancials: daPmFinancials,
    pmPlanning: daPmPlanning,
    pmPlanningPanel: daPmPlanningPanel,
    pmResources: daPmResources,
    pmDetails: daPmDetails,
  },
} as const;

/** This module's own namespaces — the ones whose da/en keys must match exactly. */
export const OWN_NAMESPACES = [
  'pmShell',
  'pmCommon',
  'pmPortfolio',
  'pmFinancials',
  'pmPlanning',
  'pmPlanningPanel',
  'pmResources',
  'pmDetails',
] as const;
